import { BlockType } from '../../factories/types';
import { defined } from '../../utils/defined';
import { ButtonWrapper } from '../button/ButtonWrapper';

export const HeaderCtaSection = (props: {
  actions: (BlockType<'button'> | undefined)[] | undefined,
  className: string,
}) =>
  <div className={props.className}>
    {
      defined(props.actions).map((action, index) =>
        <ButtonWrapper
          key={index}
          data={action}
          isPrimary={action === props.actions?.at(-1)}
        />
      )
    }
  </div>
